import React, { useState } from "react";
import './rating.css';

const StarRating = ({ rating = 0, maxRating = 5, onRatingChange = () => {}, readOnly = false }) => {
  const [hoveredRating, setHoveredRating] = useState(0);
  
  const handleMouseEnter = (index) => {
    if (!readOnly) {
      setHoveredRating(index);
    }
  };

  const handleMouseLeave = () => {
    if (!readOnly) {
      setHoveredRating(0);
    }
  };

  const handleClick = (index) => {
    if (!readOnly) {
      onRatingChange(index);
    }
  };

  const stars = [];
  
  for (let i = 1; i <= maxRating; i++) {
    const isFilled = i <= (hoveredRating || rating);
    stars.push(
      <span
        key={i}
        className={`star ${isFilled ? 'filled' : ''}`}
        onMouseEnter={() => handleMouseEnter(i)}
        onMouseLeave={handleMouseLeave}
        onClick={() => handleClick(i)}
        style={{ cursor: readOnly ? 'default' : 'pointer' }}
      >
        &#9733;
      </span>
    );
  }

  return <div className="star-rating">{stars}</div>;
};

export default StarRating;